






















































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import { getPredefinedAnswerInAdmin } from '@/modules/predefined-answer/models/columns/admin-predefined-answer.column'
import { PredefinedAnswerType } from '@/modules/predefined-answer/models/predefined-answer-collection.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminPredefinedAnswerTableRow
  from '@/modules/predefined-answer/components/admin/table/AdminPredefinedAnswerTableRow.vue'
import AdminPredefinedAnswerForm from '@/modules/predefined-answer/components/admin/AdminPredefinedAnswerForm.vue'
import {
  PredefinedAnswerCreateUseCase
} from '@/modules/predefined-answer/use-cases/admin/predefined-answer-create.use-case'
import { PredefinedAnswerResourceModel } from '@/modules/predefined-answer/models/predefined-answer-resource.model'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست پاسخ های آماده'
  },
  metaInfo: {
    title: 'لیست پاسخ های آماده'
  },
  components: {
    AdminPredefinedAnswerForm,
    BaseButton,
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly useCase: PredefinedAnswerCreateUseCase
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() predefinedAnswers: PredefinedAnswerType
  private rowComponent = AdminPredefinedAnswerTableRow
  private columns = getPredefinedAnswerInAdmin()
  private needClearForm: boolean = false
  private createBtnLabel = 'ثبت اطلاعات'
  private predefinedAnswer: PredefinedAnswerResourceModel = this.emptyAnswer()

  onSubmit() {
    this.useCase.execute(this.predefinedAnswer).then(() => {
      if (this.useCase.isSuccess) this.predefinedAnswer = this.emptyAnswer()
    })
  }

  emptyAnswer(): PredefinedAnswerResourceModel {
    return {
      id: 0,
      text: ''
    }
  }

  protected get model(): any {
    return this.predefinedAnswers
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
